import React, { useState, useEffect } from "react";
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Paper,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { ArrowDropDown, DeleteOutline, Search } from "@mui/icons-material";
// import { serverUrl } from '../server';
import { getRequest, patchRequest, server } from "../config";
import moment from "moment";
import axios from "axios";

const CancledRequest = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [customers, setCustomers] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedCity, setSelectedCity] = useState("");
  const [allCities, setallCities] = useState([]);
  const [backData, setbackData] = useState([]);
  const [actualValue, setactualValue] = useState({ name: "All Cities" });
  const [open, setOpen] = useState(false);
  const [filter, setfilter] = useState({});
  const [editOpen, seteditOpen] = useState(false);
  const [editedMessage, seteditedMessage] = useState("");
  const [selectedId, setselectedId] = useState({});
  const handleClickOpen = (id) => {
    setfilter({ subCategoryId: id?.subCategoryId, userId: id?.userId });
    setOpen(true);
  };
  useEffect(() => {
    fetchCustomers();
  }, [searchQuery, page, rowsPerPage, selectedCity]);
  const handleChange = (e) => {
    seteditedMessage(e.target.value);
  };
  const handleUpdate = async () => {
    try {
      const uri =
        server.uri +
        `CancledRequest/user?userId=${selectedId?.userId}&&subCategoryId=${selectedId?.subCategoryId}`;
      const updatedData = await patchRequest(uri);
      if (updatedData == 204) {
        seteditOpen(false);
      }
    } catch (error) {}
  };
  const handleDelete = async () => {
    try {
      const uri =
        server.uri +
        `CancledRequest/bulk?where={"subCategoryId":"${filter?.subCategoryId}","userId":"${filter?.userId}"}`;
      const deleteRequest = await axios.delete(uri);
      if (deleteRequest) {
        setOpen(false);
        await fetchCustomers();
      }
    } catch (error) {
      alert(JSON.stringify(error));
    }
  };
  // Fetch customers from the LoopBack backend with filter and pagination

  const fetchCities = async () => {
    try {
      const uri = server.uri + "cities";
      const citiesData = await getRequest(uri);
      if (citiesData) {
        setallCities(citiesData);
        setbackData(citiesData);
      }
    } catch (error) {}
  };
  useEffect(() => {
    // fetchCities();
  }, []);

  const fetchCustomers = async () => {
    try {
      const filter = {
        where: {
          or: [
            { name: { like: `%${searchQuery}%` } },
            { email: { like: `%${searchQuery}%` } },
            { pincode: { like: `%${searchQuery}%` } },
          ],
        },
        skip: page * rowsPerPage,
        limit: rowsPerPage,
      };

      const response = await getRequest(
        `${server.uri}requestlogs?filter={
        "where":{
        "or":[
        {"serviceName":{"like":"${searchQuery}"}},
       
         {"pincode":{"like":"${searchQuery}"}}
        
      ]},"skip":"${filter.skip}",
      "limit":"5",
        
        "order":"requestedAt desc","include":[{"relation":"user"}]}`
      );
      //   console.log(response);

      setCustomers(response);
      const responseCount = await getRequest(
        `${server.uri}requestlogs/count?where={
        
        "or":[
        {"serviceName":{"like":"${searchQuery}"}},
       
         {"pincode":{"like":"${searchQuery}"}}
      ]}`
      );

      console.log(responseCount);

      setTotalCount(responseCount.count);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  // Handle search query change
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setPage(0); // Reset to the first page when search changes
  };

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page when rows per page changes
  };
  const handleCityChange = (event, value) => {
    setSelectedCity(value?.name);
    setactualValue(value);
    setPage(0); // Reset to the first page when city changes
  };

  const cities = ["New York", "Los Angeles", "Chicago", "Houston", "Phoenix"]; // Example city list
  return (
    <Container>
      <Typography variant="h4" sx={{ marginTop: 8, marginBottom: 2 }}>
        Request List
      </Typography>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Delete Service"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are You Sure to Delete Service?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => handleDelete(filter)}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={editOpen} onClose={() => seteditOpen(false)}>
        <DialogTitle>Edit Message</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            multiline
            variant="outlined"
            label="Message"
            value={editedMessage}
            onChange={handleChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => seteditOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleUpdate} color="primary" variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Search Bar */}
      {/* <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
    
        <TextField
          variant="outlined"
          placeholder="Search by name/mobile number/pincode"
          fullWidth
          value={searchQuery}
          onChange={handleSearch}
          InputProps={{
            startAdornment: <Search sx={{ color: "gray", marginRight: 1 }} />,
          }}
          sx={{ marginRight: 2 }}
        />

      
        <FormControl variant="outlined" sx={{ minWidth: 200 }}>
        
          <Autocomplete
            value={actualValue}
            onChange={handleCityChange}
          
            getOptionLabel={(option) => option?.name}
            options={allCities}
            fullWidth
            freeSolo
            renderInput={(params) => (
              <TextField
                onch
                {...params}
                label="Search City"
                variant="outlined"
                fullWidth
              />
            )}
            renderOption={(props, option) => (
              <MenuItem {...props} key={option?.cityId}>
                {option?.name}
              </MenuItem>
            )}
          />
        </FormControl>
      </Box> */}
      <Typography variant="subtitle1" sx={{ textAlign: "right" }} gutterBottom>
        Total CancledRequest: <strong>{customers?.length}</strong>
      </Typography>
      {/* Customer Table */}
      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "#f4f6f8", // Light background for table header
                }}
              >
                <TableCell sx={{ fontWeight: "bold" }}>Service Name</TableCell>

                <TableCell sx={{ fontWeight: "bold" }}>Accepted Partners</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Not-Accepted Partners</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>CustomerReason</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Customer Name</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Customer Mobile</TableCell>
<TableCell sx={{ fontWeight: "bold" }}>Customer Email</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Requested At</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customers?.map((customer) => (
                <TableRow
                  sx={{
                    "&:nth-of-type(even)": {
                      backgroundColor: "#f9fafb", // Alternate row color for better readability
                    },
                  }}
                  key={customer.logId}
                >
               

                  <TableCell>{customer?.serviceName}</TableCell>
                  <TableCell>{customer?.acceptedPartners?.length}</TableCell>
                  <TableCell>{customer?.notAcceptedPartners?.length}</TableCell>
                  <TableCell>{customer?.customerReason}</TableCell>
                  <TableCell>{customer?.user?.name}</TableCell>
                  <TableCell>{customer?.user?.mobileNumber}</TableCell>
                     <TableCell>{customer?.user?.mobileNumber}</TableCell>
                      <TableCell>{customer?.user?.email}</TableCell>
                     
                  <TableCell>
                    {moment(customer?.requestedAt).startOf("hour").fromNow()}
                  </TableCell>

                  
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25,50,100,200,500,1000]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Container>
  );
};

export default CancledRequest;
